export default __webpack_public_path__ + "static/media/italiaLogo.f657530b.png";